import type React from 'react';

import { type filterKeys } from '../helper';
import { RadioBoxItems } from './radio-box-items';

export const RadioBoxItemsChild = ({
	setOpenTab,
	i,
	handleRadioState,
	handleRadioContainerClick,
	allLoader,
	onTextClick,
}: {
	setOpenTab?: React.Dispatch<React.SetStateAction<boolean>>;
	i: any;
	handleRadioState: ({ target }: React.ChangeEvent<HTMLInputElement>, key: filterKeys) => void;
	handleRadioContainerClick: (id: number, key: filterKeys) => void;
	allLoader: boolean;
	onTextClick?: (data: any, name: filterKeys) => void;
}) => (
	<>
		{i?.data?.map((j: any, index: number) => (
			<RadioBoxItems
				handleItemSelect={handleRadioState}
				handleRadioContainerClick={handleRadioContainerClick}
				name={i.name as filterKeys}
				label={j.name}
				id={j.id}
				key={index}
				checkedId={i.checkedId || 0}
				disabled={allLoader}
				setOpenTab={setOpenTab}
				onTextClick={onTextClick ? (id) => onTextClick(j, i.name) : undefined}
			/>
		))}
	</>
);
